import hrApi from '@/api/v1/hr';
import { mapSelectedFeaturesArrayToSearchFiltersObject } from '@/helpers/utils';
import assign from 'lodash/assign';

export default {
  namespaced: true,

  state: {
    candidatesList: [],
    totals: 0,
    selectedFeatures: [],
    pagination: {
      page: 1,
      itemsPerPage: 20,
      mustSort: false,
      multiSort: true,
      sortBy: [],
      sortDesc: [],
    },
    navigation: {
      project: {
        name: '',
      },
      recruitment: {
        name: '',
      },
    },
    isDataLoading: false,
  },

  mutations: {
    CHANGE_CANDIDATES(state, candidatesList) {
      state.candidatesList = candidatesList;
    },

    CHANGE_PAGINATION(state, pagination) {
      state.pagination = assign(state.pagination, pagination);
    },

    CHANGE_NAVIGATION(state, navigationData) {
      state.navigation = { ...navigationData };
    },

    CHANGE_TOTALS_NUMBER(state, totals) {
      state.totals = totals;
    },

    CHANGE_LOADING_STATUS(state, status) {
      state.isDataLoading = status;
    },

    CHANGE_SELECTED_FEATURES(state, featuresList) {
      state.selectedFeatures = featuresList;
    },
  },

  actions: {
    fetchCandidates({ state, commit }, id) {
      commit('CHANGE_LOADING_STATUS', true);

      const fetchParams = {
        recruitment_id: id,
        ...state.pagination,
        filters: mapSelectedFeaturesArrayToSearchFiltersObject(state.selectedFeatures),
      };

      return new Promise((resolve, reject) => {
        hrApi.candidates
          .index(id, fetchParams)
          .then((resp) => {
            commit('CHANGE_TOTALS_NUMBER', resp.data.pagination.itemsLength);
            commit('CHANGE_PAGINATION', resp.data.pagination);
            commit('CHANGE_CANDIDATES', resp.data.collection);
            commit('CHANGE_NAVIGATION', resp.data.navigation);
            resolve();
          })
          .catch(() => {
            reject();
          })
          .finally(() => {
            commit('CHANGE_LOADING_STATUS', false);
          });
      });
    },

    setCandidatesPagination({ commit }, pagination) {
      commit('CHANGE_PAGINATION', pagination);
    },

    createCandidate({ dispatch }, candidateData) {
      return new Promise((resolve, reject) => {
        hrApi.candidates
          .create(candidateData)
          .then((resp) => {
            dispatch('showSuccess', [resp.data.success], { root: true });
            resolve(resp);
          })
          .catch((err) => {
            dispatch('showError', err.response.data.errors, { root: true });
            reject();
          });
      });
    },

    bulkOffer({ dispatch }, candidatesIds) {
      return new Promise((resolve, reject) => {
        hrApi.candidates
          .offer({ candidates_ids: candidatesIds })
          .then((resp) => {
            dispatch('showSuccess', ['Candidates offered'], { root: true });
            resolve(resp);
          })
          .catch((err) => {
            dispatch('showError', err.response.data.errors, { root: true });
            reject();
          });
      });
    },

    deleteCandidate({ dispatch }, candidateData) {
      return new Promise((resolve, reject) => {
        hrApi.candidates
          .delete(candidateData)
          .then((resp) => {
            dispatch('showSuccess', [resp.data.success], { root: true });
            resolve(resp);
          })
          .catch((err) => {
            dispatch('showError', err.response.data.errors, { root: true });
            reject();
          });
      });
    },

    updateCandidateStatus({ dispatch }, candidateParams) {
      return new Promise((resolve, reject) => {
        hrApi.candidates
          .updatedStatus(candidateParams.id, candidateParams.status)
          .then((resp) => {
            dispatch('showSuccess', ['Status updated'], { root: true });
            resolve(resp);
          })
          .catch((err) => {
            dispatch('showError', err.response.data.errors, { root: true });
            reject();
          });
      });
    },

    createContract({ dispatch }, contract) {
      return new Promise((resolve, reject) => {
        hrApi.contracts
          .create(contract.projectId, contract.data)
          .then((resp) => {
            dispatch('showSuccess', ['Contract created'], { root: true });
            resolve(resp);
          })
          .catch((err) => {
            dispatch('showError', err.response.data.errors, { root: true });
            reject();
          });
      });
    },

    setSelectedFeatures({ commit }, featuresList) {
      commit('CHANGE_PAGINATION', { page: 1 });
      commit('CHANGE_SELECTED_FEATURES', featuresList);
    },
  },
};
